module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Medium.eb76c06.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Medium.woff2
// module id = kB21
// module chunks = 0